// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2313":"e65142d723fdb0e6","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","6048":"a6a5244704d2db39","6572":"0c0c27263b6c29ee","9700":"d3dc3f3c1c42f3ca"}[chunkId] + ".css";
};